export default __webpack_public_path__ + "static/media/4b.6c3816a7.png";